import { render, staticRenderFns } from "./viewBinItemsList.vue?vue&type=template&id=46b5f1ec&scoped=true"
import script from "./viewBinItemsList.vue?vue&type=script&lang=js"
export * from "./viewBinItemsList.vue?vue&type=script&lang=js"
import style0 from "./viewBinItemsList.vue?vue&type=style&index=0&id=46b5f1ec&prod&scoped=true&lang=css"
import style1 from "./viewBinItemsList.vue?vue&type=style&index=1&id=46b5f1ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5f1ec",
  null
  
)

export default component.exports